import { formatDateTime } from "../../lib/orders";
import { useClientPayments } from "../../lib/useClients";

const STATUS_BADGE: Record<string, string> = {
  verified: "green",
  pending: "yellow",
  pending_admin_review: "yellow",
  rejected: "red",
  duplicate: "gray",
};

const STATUS_LABEL: Record<string, string> = {
  verified: "Подтверждён",
  pending: "В обработке",
  pending_admin_review: "На проверке",
  rejected: "Отклонён",
  duplicate: "Дубликат",
};

export function ClientPaymentsTab({ clientId }: { clientId: string }) {
  const { data, isLoading } = useClientPayments(clientId);
  const payments = data ?? [];

  if (isLoading) {
    return (
      <div className="cd-empty">
        <p>Загрузка…</p>
      </div>
    );
  }

  if (payments.length === 0) {
    return (
      <div className="cd-empty">
        <span style={{ fontSize: 32 }}>💳</span>
        <p>Ещё не было платежей</p>
      </div>
    );
  }

  const total = payments.reduce(
    (s, p) => s + (p.aiPaidAmount ? Number(p.aiPaidAmount) : 0),
    0,
  );

  return (
    <>
      <div className="cd-pay-total">
        <span>Подтверждено</span>{" "}
        <b>{total.toLocaleString("ru-RU")} GEL</b>{" "}
        <span className="muted">
          · {payments.length}{" "}
          {payments.length === 1 ? "операция" : "операции"}
        </span>
      </div>
      <table className="data cd-pay-table">
        <thead>
          <tr>
            <th>Дата</th>
            <th>Статус</th>
            <th className="num">Сумма</th>
            <th>Заказ</th>
          </tr>
        </thead>
        <tbody>
          {payments.map((p) => (
            <tr key={p.id}>
              <td className="muted">{formatDateTime(p.createdAt)}</td>
              <td>
                <span className={"badge-a " + (STATUS_BADGE[p.status] ?? "gray")}>
                  {STATUS_LABEL[p.status] ?? p.status}
                </span>
              </td>
              <td className="num tnum bold">
                {p.aiPaidAmount ? `+${p.aiPaidAmount}` : "—"}
              </td>
              <td className="mono" style={{ fontSize: 11 }}>
                {p.orderId ?? p.shopOrderId ?? "—"}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
}
